import { render, staticRenderFns } from "./Rhombus.vue?vue&type=template&id=6b32181b&scoped=true&"
import script from "./Rhombus.vue?vue&type=script&lang=js&"
export * from "./Rhombus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b32181b",
  null
  
)

export default component.exports